// extracted by mini-css-extract-plugin
module.exports = {"faq-header":"_2k8o2","sub":"_3XllB","sections":"_31Rvj","container":"_274an","section-wrapper":"_3tgEU","faq-wrapper":"-sVt_"};